import { login } from "../../api/config/modules/Login";

const state = {
  login: {},
};

const mutations = {
  SET_LOGIN: (state, login) => {
    console.log(state)
    state.login = login;
  },
};

const actions = {
  GET_LOGIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      login(data)
        .then((res) => {
          commit("SET_LOGIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
